import Passage from '@app/components/ui/passage';
import { IdleBunny } from '@app/components/ui/bunny';
import Reveal from '@app/components/ui/reveal';
import { ProfileDto } from '@app/models/dtos/contentDto';

export default function Closing({ profile, stack }: { profile: ProfileDto; stack: string[] }) {
    return (
        <Passage id="contact">
            <Reveal>
                <div className="relative flex items-end gap-4">
                    <IdleBunny say="say hi!" size={40} duration={7} className="shrink-0" />
                    <p className="t-script-sm pb-1 text-accent">Bunny is here to help you.</p>
                </div>

                <p className="t-body mt-6 text-body">
                    Open to interesting work. Say hello at{' '}
                    <a href={`mailto:${profile.email}`} className="link">
                        {profile.email}
                    </a>
                    , and Bunny will make sure it reaches me.
                </p>

                <p className="t-small mt-8 text-muted">{stack.join(' · ')}</p>
            </Reveal>
        </Passage>
    );
}
